import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {useRouter} from '@uirouter/react'
import {FilterSelect} from '@mdsol/onex-design'
import {refreshJobs} from 'redux/jobs/jobs.duck'
import {select_gridSession_filters, select_gridSession_filtersOptions_raveUrl} from 'redux/jobs/selectors'
import {getSelectedFilterOptions, getSelectedRaveUrlFilterOptions} from 'helpers/jobs'

import {JobType, JobStatus} from 'graphql-api'
import {JobStatusType, JobTypeType} from 'commonTypes'
import {FiltersType} from 'redux/jobs/state'

import './filtersPanel.scss'

const FiltersPanel: FC = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const selectedFilters = useSelector(select_gridSession_filters)
  const {
    jobType: selectedJobTypeFilters,
    jobStatus: selectedJobStatusFilters,
    databaseId: selectedRaveUrlFilters,
  } = selectedFilters

  const jobTypeOptions = getSelectedFilterOptions(Object.values(JobType) as [JobTypeType])
  const jobStatusOptions = getSelectedFilterOptions(Object.values(JobStatus) as [JobStatusType])
  const raveUrlOptions = useSelector(select_gridSession_filtersOptions_raveUrl)

  const handleApplyFilters = (filters: FiltersType) => {
    dispatch(refreshJobs(router, undefined, undefined, filters))
  }

  const handleJobTypeFilterChange = selectedJobTypeOptions => {
    const jobTypeFilters = selectedJobTypeOptions.map(selectedJobTypeOption => selectedJobTypeOption.value)

    handleApplyFilters({
      ...selectedFilters,
      jobType: jobTypeFilters,
    })
  }

  const handleJobStatusFilterChange = selectedJobStatusOptions => {
    const jobStatusFilters = selectedJobStatusOptions.map(selectedJobStatusOption => selectedJobStatusOption.value)

    handleApplyFilters({
      ...selectedFilters,
      jobStatus: jobStatusFilters,
    })
  }

  const handleRaveUrlFilterChange = selectedRaveUrlOptions => {
    const raveUrlFilters = selectedRaveUrlOptions.map(selectedRaveUrlOption => selectedRaveUrlOption.value)

    handleApplyFilters({
      ...selectedFilters,
      databaseId: raveUrlFilters,
    })
  }

  return (
    <div id='jobs-filters-panel' className='onex-data-grid-filters'>
      <div className='onex-data-grid-filters-container'>
        <div className='onex-data-grid-filters-wrapper'>
          <FilterSelect
            dataTestId='rave-url-filter'
            label='Url'
            isMulti
            isSearchable
            selectAll
            selectAllLabel='All Urls'
            displayApplyButton={false}
            value={getSelectedRaveUrlFilterOptions(selectedRaveUrlFilters, raveUrlOptions)}
            options={raveUrlOptions}
            onChange={handleRaveUrlFilterChange}
          />
        </div>
        <div className='onex-data-grid-filters-wrapper'>
          <FilterSelect
            dataTestId='job-type-filter'
            label='Job Type'
            isMulti
            isSearchable
            selectAll
            selectAllLabel='All Job Types'
            displayApplyButton={false}
            value={getSelectedFilterOptions(selectedJobTypeFilters)}
            options={jobTypeOptions}
            onChange={handleJobTypeFilterChange}
          />
        </div>
        <div className='onex-data-grid-filters-wrapper'>
          <FilterSelect
            dataTestId='job-status-filter'
            label='Job Status'
            isMulti
            isSearchable={false}
            selectAll
            selectAllLabel='All Job Statuses'
            displayApplyButton={false}
            value={getSelectedFilterOptions(selectedJobStatusFilters)}
            options={jobStatusOptions}
            onChange={handleJobStatusFilterChange}
          />
        </div>

      </div>
    </div>
  )
}

export default FiltersPanel
